<template lang="pug">
  a(
  v-if="col === reportConfig.col && reportConfig.isEmpty !== true"
  ).report
    div.report-name {{$translate(reportConfig.title)}}
    div.buttons
      router-link(
      tag="button"
      :to="reportConfig.to || {name: 'analytic.reports.report', params: {reportId: reportConfig.id, windowType: reportConfig.windowType}}"
      ).row-download--no-border.blue
</template>

<script>
  export default {
    name: "report-card",
    props: {
      reportConfig: {
        type: Object,
        default: () => ({
          col: 0,
          isEmpty: false,
          title: '',
          id: '',
          windowType: ''
        })
      },
      col: Number
    }
  }
</script>
